/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { formatItemName, formatLocationName } from '../utils/stringUtils';
import { metersToMiles } from '../utils/tripUtils';

const propTypes = {
    destination: PropTypes.object,
    destinationIndex: PropTypes.number,
    onMoveUpDestination: PropTypes.func,
    onMoveDownDestination: PropTypes.func,
    onDeleteDestination: PropTypes.func,
    onSelected: PropTypes.func,
    editable: PropTypes.bool,
};

export default class TripItineraryArrival extends React.Component {
    constructor(props) {
        super(props);
        this.moveUpDestination = this.moveUpDestination.bind(this);
        this.moveDownDestination = this.moveDownDestination.bind(this);
        this.deleteDestination = this.deleteDestination.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        if (this.props.onSelected) {
            this.props.onSelected(this.props.destinationIndex);
        }
    }

    moveUpDestination(e) {
        if (this.props.onMoveUpDestination) {
            this.props.onMoveUpDestination(e);
        }
    }

    moveDownDestination(e) {
        if (this.props.onMoveDownDestination) {
            this.props.onMoveDownDestination(e);
        }
    }

    deleteDestination(e) {
        if (this.props.onDeleteDestination) {
            this.props.onDeleteDestination(e);
        }
    }

    render() {
        const name = formatItemName(this.props.destination);
        const miles = metersToMiles(this.props.destination.distance);
        const item = this.props.destination;

        return (
            <div className="trip-planner-itinerary-arrival">
                <div className="trip-planner-itinerary-icon">
                    <span>{this.props.destinationIndex + 1}</span>
                </div>
                <div className="trip-planner-itinerary-location">
                    <span className="label">
                        ARRIVE (DESTINATION {this.props.destinationIndex + 1}){' '}
                        {miles ? `~ ${miles} miles` : ''}
                    </span>
                    <button
                        type="button"
                        className="rec-button-link"
                        onClick={this.onClick}
                    >
                        <strong>{name}</strong>
                    </button>
                    <ul className="rec-card-meta">
                        {item.parent_name && item.parent_name.length > 0 && (
                            <li>{formatLocationName(item.parent_name)}</li>
                        )}
                        {(!item.parent_name || !item.parent_name.length === 0) &&
                            item.org_name &&
                            item.org_name.length > 0 && (
                                <li>{formatLocationName(item.org_name)}</li>
                            )}
                        {item.city && item.state_code && (
                            <li>
                                Near {item.city}, {item.state_code}
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        );
    }
}

TripItineraryArrival.propTypes = propTypes;
